import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Korisnici from "./View";
import { getUsers, deleteUser } from "./modules/actions";
import { getSuppliers } from "../Dobavljaci/modules/actions";

const mapStateToProps = (state) => ({
  state: {
    users: state.usersReducer.users,
    suppliers: state.suppliersReducer.suppliers,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      getUsers,
      deleteUser,
      getSuppliers,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Korisnici);
